'use client';

import {Table as TanstackTable, flexRender} from '@tanstack/react-table';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shadcn_components/ui/table';

import {DataTablePagination} from './data-table-pagination';
import {DataTableToolbar} from './data-table-toolbar';
import {ReactNode} from 'react';

interface DataTableProps<TData> {
  // columns: ColumnDef<TData, TValue>[];
  toolbar?: ReactNode;
  table: TanstackTable<TData>;
}

export function DataTable<TData = any>(props: DataTableProps<TData>) {
  const {toolbar, table} = props;
  return (
    <div className="space-y-2">
      {toolbar === undefined ? <DataTableToolbar table={table} /> : toolbar}
      <div className="rounded-md border overflow-auto">
        <Table>
          <TableHeader className="rounded-md bg-gray-100">
            {table.getHeaderGroups().map(headerGroup => (
              <TableRow key={headerGroup.id}>
                {headerGroup.headers.map(header => {
                  return (
                    <TableHead key={header.id} colSpan={header.colSpan}>
                      {header.isPlaceholder
                        ? null
                        : flexRender(header.column.columnDef.header, header.getContext())}
                    </TableHead>
                  );
                })}
              </TableRow>
            ))}
          </TableHeader>
          <TableBody>
            {table.getRowModel().rows?.length ? (
              table.getRowModel().rows.map(row => (
                <TableRow key={row.id} data-state={row.getIsSelected() && 'selected'}>
                  {row.getVisibleCells().map(cell => (
                    <TableCell key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={table.getAllColumns().length} className="h-24 text-center">
                  Không có dữ liệu
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      <DataTablePagination table={table} />
    </div>
  );
}
